import { Component } from 'react';

const animationDelayMs = 100;
const animationProgressPx = 19;

export default function withAnimationControl(MyComponent) {
  return class WithAnimationControl extends Component {
    constructor(props) {
      super(props);

      this.state = {
        isRecurlyLoading: true,
      };

      this.setRecurlyLoadingState = this.setRecurlyLoadingState.bind(this);
      this.startFakeAuthTransition = this.startFakeAuthTransition.bind(this);
    }

    setRecurlyLoadingState(isLoading) {
      if (isLoading !== this.state.isRecurlyLoading) {
        // this is to delay the animation start after the loading is complete
        setTimeout(
          () =>
            this.setState({
              isRecurlyLoading: isLoading,
            }),
          animationDelayMs,
        );
      }
    }

    startFakeAuthTransition(node) {
      if (node) {
        const height = node.getBoundingClientRect().height || 0;
        this.transitionFakeAuth(height, node.parentNode);
      }
    }

    transitionFakeAuth(height, parent) {
      let progress = 0;

      const step = () => {
        // controls the animation speed
        progress += animationProgressPx;

        // if the height provided, isn't perfectly divisible by
        // progress, this will finish the animation by the
        // exact amount
        if (progress > height) {
          progress = height;
        }

        /* eslint-disable no-param-reassign */
        parent.style.transform = `translateY(-${progress}px)`;

        if (progress < height) {
          window.requestAnimationFrame(step);
        }
      };

      window.requestAnimationFrame(step);
    }

    render() {
      return (
        <MyComponent
          {...this.props}
          setRecurlyLoadingState={this.setRecurlyLoadingState}
          isRecurlyLoading={this.state.isRecurlyLoading}
          startFakeAuthTransition={this.startFakeAuthTransition}
        />
      );
    }
  };
}
